import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import Select from "react-select";
import { modificarCategoria, crearCategoria } from "../../../api/api-categoria";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { sharedNextPage } from "../../../utils/shared-functions";
import { useProcessing, useToast } from "../../../utils/context/ui-feedback-context";
import { FormActionsBar, FormCancelButton, FormSubmitButton } from "../../../components/form-actions-component";
import ColorPickerComponent from "../../../components/color-picker-component";

export default function CategoriaPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();

  const [sendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    // console.log("entro a Categoria");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data === undefined || data === null) {
        sharedNextPage("listar-categoria", {}, history);
        return;
      }
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      // const categorias = await obtenerListaCategoria({ habilitado: 1 }, true);
      // setListaCategoria(categorias);
      // if (data.params.idCategoria !== undefined && data.params.idCategoria !== null) {
      //   const categoria = categorias.find((item) => item.value === data.params.idCategoria);
      //   setCategoriaSelected(categoria);
      // }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
    color: 7,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        showToast(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    try {
      // console.log('handleSaveClick');
      // lógica para guardar los cambios
      // console.log('formData');
      // console.log(formData);
      const valido = validarFormulario();
      if (valido === false) {
        return;
      }
      let objEnviar = {};
      objEnviar.id = formData.id;
      objEnviar.codigo = formData.codigo;
      objEnviar.descripcion = formData.descripcion;
      objEnviar.nota = formData.nota;
      objEnviar.color = formData.color;
      showProcessing();
      setSendRequest(true);
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearCategoria(objEnviar);
        hideProcessing();
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await modificarCategoria(objEnviar);
        hideProcessing();
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (error) {
      console.log('handleSaveClick error');
      console.log(error);
    } finally {
      setSendRequest(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="categoria">
                  {t("label_categoria")}
                </label>
                <Select options={listaCategoria}
                  isSearchable='true'
                  isClearable='true'
                  value={categoriaSelected}
                  onChange={(event) => setCategoriaSelected(event)}
                  placeholder={t("placeholder_seleccione_categoria")}
                />
              </div>
            </div>
            <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nombre}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <ColorPickerComponent
                  value={formData.color}
                  onChange={(color) => setFormData({ ...formData, color })}
                  maxLength={charLimits.color}
                />
              </div>
            </div>
            <FormActionsBar>
              <FormCancelButton
                label={t("btn_cancelar")}
                onClick={handleCancelClick}
                disabled={sendRequest}
              />
              <FormSubmitButton
                loading={sendRequest}
                onClick={handleSaveClick}
                label={t("btn_guardar")}
                variant="primary"
              />
            </FormActionsBar>
          </div>
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
